export const getAffiliates = (state) => state.affiliates
